import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, CampaignWithPreviewDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { TableWrapperOptions } from '../../../../services/global/global-interfaces';
import { CampaignReportingService } from '../../../../services/campaign-reporting.service';
import { PermissionService } from '../../../../services/permission.service';

@Component({
  selector: 'sb-page-company-details-campaigns',
  templateUrl: './company-details-campaigns.component.html',
  styleUrls: ['./company-details-campaigns.component.scss'],
  standalone: false,
})
export class CompanyDetailsCampaignsComponent implements OnInit {
  companyId: number;
  loading: boolean;

  campaignData: CampaignWithPreviewDTO[] = [];
  debounceTimer: ReturnType<typeof setTimeout>;
  options: TableWrapperOptions;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    private campaignsService: CampaignReportingService,
    public permissionService: PermissionService
  ) {
    this.companyId = undefined;
    this.loading = true;
    this.campaignData = [];
    this.debounceTimer = null;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.companyId = +params.companyID;
    });
  }

  getCompanyId() {
    return this.companyId;
  }

  requestDebounced(options?: TableWrapperOptions) {
    if (options) {
      this.options = options;
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    this.loading = true;
    if (this.options?.pagination) {
      this.api
        .ds_cm_Campaign_retrieveAllFrontendEnhanced(
          {
            search: this.util.encodeSearchQueryParam(this.options.exactMatch, this.options.search),
            company: [this.companyId],
          },
          this.options.pagination
        )
        .subscribe({
          next: (res: CampaignWithPreviewDTO[]) => {
            this.campaignData = res;
            if (this.permissionService.hasPermission(this.permissionService.Permission.ds_cm_reporting)) {
              this.campaignData = this.campaignsService.getAndMergePulseChart(res);
            }
            this.loading = false;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
